import carousel from './carousel';
import { getBreakpoint } from './_utils';
import _debounce from 'lodash/debounce';

const componentName = 'UGCGrid';
const flickityBreakpoints = ['xxsmall', 'xsmall', 'small'];
let slides;
const update = () => {
	if (flickityBreakpoints.includes(getBreakpoint())) {
		if (!slides) {
			slides = carousel(componentName, flickityBreakpoints, { wrapAround: false });
		}
	} else if (slides) {
		slides.forEach(({ $carouselContainer, flickity }) => {
			if ($carouselContainer.hasClass(componentName)) {
				$carouselContainer.removeClass(`${componentName}--flickity`);
				flickity.destroy();
			}
			return false;
		});
		slides = null;
	}
};
export default function initCarousels() {
	update();
	$(window).on('resize', _debounce(update, 100));
}
